import { FETCH_CTL_RULES } from "../types/ctlRules";

export const fetchCtlRules = () => {
  return dispatch => {
    dispatch({
      type: FETCH_CTL_RULES
    });
  };
};
